import { render, staticRenderFns } from "./NbaProjection.vue?vue&type=template&id=01f2c688&scoped=true"
import script from "./NbaProjection.vue?vue&type=script&lang=js"
export * from "./NbaProjection.vue?vue&type=script&lang=js"
import style0 from "./NbaProjection.vue?vue&type=style&index=0&id=01f2c688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f2c688",
  null
  
)

export default component.exports